<template>
  <b-container>
    <!--      breadcrumb-->
    <b-row>
      <b-breadcrumb>
        <b-breadcrumb-item>Home</b-breadcrumb-item>
      </b-breadcrumb>
    </b-row>
    <!--      button panel -->
    <b-tabs
      align="center"
      fill
      active-nav-item-class="font-weight-bold text-primary"
    >
      <b-tab
        active
        title="All"
        @click="selectedStatus = 'all'">
      </b-tab>
      <b-tab
        title="Approved"
        @click="selectedStatus = 'APPROVED'">
      </b-tab>
      <b-tab
        title="Rejected"
        @click="selectedStatus = 'REJECTED'"></b-tab>
    </b-tabs>
    <b-table
      @row-clicked="gotoOtCustomer"
      hover
      striped
      class="m-2"
      :fields="fields"
      :items="options">
      <template #cell(customerData)="data">

            <b-avatar :src="data.value.profilePicture">

            </b-avatar>

            <span class="ml-2">{{ data.value.fName }}</span>

        <b-badge :variant="data.value.variant">{{ data.value.value }}</b-badge>
      </template>
      <template #cell(status)="data">
        <b-badge :variant="data.value.variant">{{ data.value.value }}</b-badge>
      </template>
    </b-table>
    <!--      table data -->
    <b-row class="mt-3">
      <b-col>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { HTTP2 } from '@/axios/http-common'
import moment from 'moment'

export default {
  name: "Otpoints",
  data() {
    return {
      id            : '',
      fields        : [
        {
          key  : 'customerData',
          label: 'Customer'
        },
        {
          key  : 'registrationNumber',
          label: 'Vehicle No'
        },
        'amount',
        {
          key      : 'createdAt',
          label    : 'Claim Date',
          formatter: value => {
            return moment( value )
              .format( 'LL' )
          }
        },
        {
          key      : 'status',
          label    : 'Status',
          formatter: value => {
            return value === 'UNDER REVIEW' ? {
              value,
              variant: 'warning'
            } : value === 'REJECTED' ? {
              value,
              variant: 'danger'
            } : {
              value,
              variant: 'success'
            }
          }
        }
      ],
      options       : [],
      selectedStatus: 'all'
    }
  },
  async created() {
    const { data } = await HTTP2.post( 'dash/fuel/cashback' )
    this.options = data
  },
  watch: {
    selectedStatus() {
      this.fetchAll()
    }
  },

  methods: {
    gotoOtCustomer( item ) {
      this.$router.push( '/rewards/customer/' + item.customer )
    },
    async fetchAll() {
      let obj = {}
      if (this.selectedStatus !== 'all') {
        obj.status = this.selectedStatus
      }
      const { data } = await HTTP2.post( 'dash/fuel/cashback', obj )
      this.options = data
    }

  }

}
</script>
<style scoped>
</style>
